<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入名称"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-select
        class="mr10 search-item"
        v-model="type"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        class="mr10 search-item"
        v-model="status"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in statusOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        class="mr10 search-item"
        v-model="manageOpen"
        placeholder="请选择"
        size="small"
      >
        <el-option
          v-for="item in manageOpenOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column width="190px" align="center" label="培训封面">
        <template #default="scope">
          <el-image
            fit="cover"
            class="cover"
            v-if="scope.row.cover"
            :src="$utils.fileUrl(scope.row.cover)"
            :preview-src-list="[`${$utils.fileUrl(scope.row.cover)}`]"
          >
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="课程名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="topicName"
        label="所属专辑"
      ></el-table-column>
      <el-table-column prop="companyName" label="发布者" align="center">
      </el-table-column>
      <el-table-column label="公开类型" align="center">
        <template #default="scope"
          >{{ scope.row.type === 1 ? "公开课" : "私教课" }}
        </template>
      </el-table-column>
      <el-table-column label="上架状态" align="center">
        <template #default="scope"
          >{{ scope.row.status === 0 ? "下架" : "上架" }}
        </template>
      </el-table-column>
      <el-table-column label="查看评论" align="center">
        <template #default="scope">
          <el-button
            size="mini"
            @click="$router.push(`/train/video/evaluate/${scope.row.id}`)"
            type="text"
            >查看评论</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="查看详情" align="center">
        <template #default="scope">
          <el-button size="mini" type="text" @click="info(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="链接地址" align="center">
        <template #default="scope">
          <el-button size="mini" type="primary" @click="player(scope.row)"
            >播放视频</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            v-if="scope.row.manageOpen === 0"
            @click="handleEdit(scope.row.id, 1)"
            >恢复展示</el-button
          >
          <el-button
            type="danger"
            size="mini"
            v-if="scope.row.manageOpen === 1"
            @click="handleEdit(scope.row.id, 0)"
            >禁止展示</el-button
          >
          <el-button type="danger" size="mini" @click="delData(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
    <!-- 播放视频 -->
    <el-dialog
      title="视频播放"
      v-model="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="video" v-if="dialogVisible">
        <Aliplayer :source="itemData.video"></Aliplayer>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title="课程详情"
      v-model="infoDialog"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="video-info">
        <div class="cover-title">
          <div
            class="cover"
            :style="`background-image:url(${$utils.fileUrl(itemData.cover)})`"
          ></div>
          <div>
            <h2>{{ itemData.name }}</h2>
            <li>{{ itemData.companyName }}</li>
          </div>
        </div>
        <li>
          <span>{{ itemData.type === 1 ? "公开课" : "私教课" }}</span>
          <span>{{ itemData.status === 0 ? "已下架" : "已上架" }}</span>
          <span class="date">{{
            $utils.formatDate(itemData.createTime, "yyyy-MM-dd hh:mm:ss")
          }}</span>
        </li>
        <li>所属专题：{{ itemData.topicName }}</li>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="infoDialog = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Aliplayer from "./../../../components/Aliplayer";
export default {
  components: { Aliplayer },
  data() {
    return {
      data: {},
      type: "",
      searchName: "",
      infoDialog: false,
      dialogVisible: false,
      options: [
        { label: "全部", value: 0 },
        { label: "公开课", value: 1 },
        { label: "私教课", value: 2 },
      ],
      status: null,
      statusOption: [
        { label: "全部", value: 2 },
        { label: "下架", value: 0 },
        { label: "上架", value: 1 },
      ],
      manageOpen: null,
      manageOpenOption: [
        { label: "全部", value: 2 },
        { label: "正常展示", value: 1 },
        { label: "被禁止展示", value: 0 },
      ],
      itemData: {},
    };
  },
  methods: {
    async getData(page) {
      const params = {
        searchName: this.searchName,
        type: this.type,
        status: this.status,
        currentPage: page,
        pageSize: 20,
        manageOpen: this.manageOpen,
      };
      this.$loading.start();
      const res = await this.$api.train.video.getData(params);
      this.$loading.done();
      if (res.code === 10200) {
        this.data = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEdit(id, status) {
      if (!this.loading) {
        const text = status === 0 ? "是否确认禁止展示？" : "是否确认恢复？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: id,
              manageOpen: status,
            };
            const res = await this.$api.train.video.setData(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              this.$message.success("操作成功！");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {});
      }
    },
    delData(id) {
      if (!this.loading) {
        this.$confirm("是否确认删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            this.loading = true;
            this.$loading.start();
            const params = {
              id: id,
            };
            const res = await this.$api.train.video.delData(params);
            this.loading = false;
            this.$loading.done();
            if (res.code === 10200) {
              this.getData(this.data.current);
              this.$message.success("删除成功！");
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(() => {});
      }
    },
    player(data) {
      if (data.video === null) {
        this.$message.warning("视频还在转码中请稍后再试");
      } else {
        this.itemData = data;
        this.dialogVisible = true;
      }
    },
    info(data) {
      this.itemData = data;
      this.infoDialog = true;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.search-item {
  width: 140px;
}

.handle-box {
  margin-bottom: 20px;
}

.cover {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.video {
  height: 500px;
}

.video-info {
  .cover-title {
    display: flex;
    align-items: center;

    .cover {
      width: 120px;
      margin-right: 24px;
    }

    h2 {
      font-weight: 500;
      margin-bottom: 15px;
      font-size: 1.125rem;
    }
  }

  li {
    display: flex;
    margin-top: 15px;
    line-height: 30px;

    .date {
      margin-left: auto;
    }
  }
}
</style>